"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showNewSellerCard = exports.safeStringify = exports.isProfilePageEdit = exports.isProfilePage = exports.isDraft = exports.getTrackingString = exports.getQueryParam = exports.get = exports.clone = void 0;

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (_, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }

      seen.add(value);
    }

    return value;
  };
};

const safeStringify = jsonObj => JSON.stringify(jsonObj, getCircularReplacer());

exports.safeStringify = safeStringify;

const get = (object, path, defaultValue) => {
  if (!object) {
    return typeof defaultValue !== 'undefined' ? defaultValue : object;
  }

  let internalObject = object;
  const seg = path.indexOf('.') !== -1 ? path.split('.') : [path];

  while (internalObject && seg.length) {
    internalObject = internalObject[seg.shift().replace(/[\[\]']+/g, '')];
  }

  return internalObject !== undefined ? internalObject : defaultValue;
};

exports.get = get;

const getQueryParam = (out, queryParam) => {
  if (typeof window === 'object') {
    return new URL(window.location.href).searchParams.get(queryParam);
  }

  return get(out, `global.req.query.${queryParam}`);
};

exports.getQueryParam = getQueryParam;

const isDraft = out => getQueryParam(out, 'draft') === 'true';

exports.isDraft = isDraft;

const clone = model => JSON.parse(JSON.stringify(model));

exports.clone = clone;

const getTrackingString = (object, pathToTrackingList, keyValue) => {
  let tracking;

  if (object && pathToTrackingList) {
    const trackingList = get(object, pathToTrackingList, []);

    if (keyValue && Object.keys(keyValue).length) {
      const keys = Object.keys(keyValue);
      const key = keys.length && keys[0];
      const list = trackingList.filter(item => {
        if (item[key] === keyValue[key]) {
          return true;
        }
      });
      tracking = list.length && list[0];
    } else {
      tracking = trackingList.length && trackingList[0];
    }
  }

  return tracking ? JSON.stringify(tracking) : '';
};

exports.getTrackingString = getTrackingString;

const isProfilePage = page => {
  const presenceType = get(page, 'modules.PRESENCE_INFORMATION_MODULE.presenceType', '');
  return presenceType === 'BUYER' || presenceType === 'SELLER';
};

exports.isProfilePage = isProfilePage;

const isProfilePageEdit = page => !!get(page, 'modules.PRESENCE_INFORMATION_MODULE.editProfileAction', null); // TODO: Remove once it's determined that str-seller-card is to be permanent


exports.isProfilePageEdit = isProfilePageEdit;

const showNewSellerCard = page => {
  const epVersion = get(page, 'modules.PRESENCE_INFORMATION_MODULE.epVersion', '');
  return epVersion === 'smaller-seller-card' || isProfilePage(page);
};

exports.showNewSellerCard = showNewSellerCard;